import { render, staticRenderFns } from "./Animjs.vue?vue&type=template&id=5dbff520&"
import script from "./Animjs.vue?vue&type=script&lang=js&"
export * from "./Animjs.vue?vue&type=script&lang=js&"
import style0 from "./Animjs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports